<!-- MFITTで電波状況が悪くてAPIエラーになった場合 -->
<template>
  <ItemDialog ref="hasSameTicket" image-type="alert">
    <template #content-area>
      <p class="text-center">
        すでに購入前の予約済みのチケットを所持しています。<br />
        同一日・同一区間の予約は1件のみ可能です。
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogHasSameTicket",
  props: {
    closeButtonClicked: {
      type: Function,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const hasSameTicket = ref(null);

    const openDialog = () => {
      hasSameTicket.value.open();
    };

    const closeDialog = () => {
      if (props.closeButtonClicked == null) {
        hasSameTicket.value.close();
      } else {
        props.closeButtonClicked();
      }
    };

    return {
      hasSameTicket,
      openDialog,
      closeDialog,
    };
  },
};
</script>
